import { jsx as _jsx } from "react/jsx-runtime";
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import timezoneLang from 'i2l?query=sporks!timezone-utils/lang/en.lyaml';

function changeLocale(locale, language) {
  const I18nProvider = createPublicI18nProvider({
    manuallySetLocale: true,
    excludeFallback: true
  });
  const translationsAvailablePromise = Promise.all([I18nProvider.register(lang), I18nProvider.register(timezoneLang)]);
  const langEnabled = language !== 'en';
  I18nProvider.setLocale({
    locale,
    langEnabled
  });
  return translationsAvailablePromise;
}

export default function connectI18nLoader(WrappingComponent) {
  function I18nLoader(props) {
    return /*#__PURE__*/_jsx(WrappingComponent, Object.assign({}, props, {
      changeLocale: changeLocale
    }));
  }

  I18nLoader.displayName = WrappingComponent.displayName ? `connectI18nLoader(${WrappingComponent.displayName})` : 'connectI18nLoader(Component)';
  return I18nLoader;
}